import React from 'react';
import { Slider } from '@mui/material';
import { Forms, SystemText } from '@salesperformanceint/e4shared';
import { useSelector } from 'react-redux';
import { styled } from '@mui/material/styles';

const StyledSlider = styled(Slider)(({ theme }) => ({
    color: '#21154A', // sets track & thumb color
    '& .MuiSlider-rail': {
        color: '#ccc', // unfilled bar color
    },
    '& .MuiSlider-thumb': {
        backgroundColor: '#fff', // thumb background
        border: '2px solid #21154A', // thumb border
        width: 12, // smaller width
        height: 12, // smaller height
    },
    '& .MuiSlider-valueLabel': {
        backgroundColor: '#21154A', // label background
        color: '#fff', // label text color
        fontSize: 12,
    },
}));

export const BehaviourField = ({ field, onChange }) => {
    const [values, setValues] = React.useState(field.value);
    const [sortedCompetencies, setSortedCompetencies] = React.useState([]);

    const { competencies } = useSelector(state => state.dashboard);
    const ratingsRange = useSelector(state => state.user.user.companySettings?.display?.ratingRange || 5);

    React.useEffect(() => {
        if (competencies) {
            setSortedCompetencies(
                competencies.map(x => ({ ...x, name: x.full_Name })).sort((a, b) => (a.name > b.name ? 1 : -1))
            );
        }
    }, [competencies]);

    const updateValues = newValues => {
        const temp = [...newValues];
        onChange?.(temp);
    };

    React.useEffect(() => {
        if (field.value) {
            setValues(field.value);
        }
    }, [field?.value]);

    const addNew = () => {
        const temp = [...values].concat([{ id: null, range: [1, ratingsRange] }]);
        updateValues(temp);
    };

    const placeholderText = SystemText('General/Controls/Filters/Behaviour/Placeholder');
    const addText = SystemText('General/Controls/Filters/Add');
    const scoreText = SystemText('General/Controls/Filters/Behaviour/Score');

    return (
        <div>
            {values.map((value, i) => {
                const setCompetencyId = (i, x) => {
                    const temp = [...values];
                    const curr = temp[i];
                    curr.id = x;
                    updateValues(temp);
                };

                const setRange = (i, x) => {
                    const temp = [...values];
                    const curr = temp[i];
                    curr.range = x;
                    updateValues(temp);
                };

                return (
                    <div key={`behaviour-filter-${values.id || 0}`}>
                        <div>
                            <Forms.Select
                                data={sortedCompetencies}
                                value={value.id}
                                onChange={x => setCompetencyId(i, x)}
                                placeholder={placeholderText}
                                mandatory
                            />
                        </div>
                        <div className="behaviour-score ml3 mt5">{scoreText}</div>
                        <div className="pr10 pl10 mt25">
                            <StyledSlider
                                step={1}
                                min={1}
                                max={ratingsRange}
                                value={value.range}
                                onChange={(e, x) => setRange(i, x)}
                                valueLabelDisplay="on"
                            />
                        </div>
                    </div>
                );
            })}
            <div className="ml3">
                <button className="btn btn-link text-primary" onClick={addNew}>
                    <i className="fa fa-plus-circle mr10" />
                    {addText}
                </button>
            </div>
        </div>
    );
};

export default BehaviourField;
